function dm_single(){
    const sections = document.querySelectorAll('.single');
    if (!sections.length) return;

    let copyBtn = document.getElementById('copyLinkBtn');
    let tooltip = new bootstrap.Tooltip(copyBtn);

    copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        let link = copyBtn.getAttribute('href');
        navigator.clipboard.writeText(link).then(() => {
        tooltip.setContent({ '.tooltip-inner': 'Copied!' });
        tooltip.show();
        setTimeout(() => {
            tooltip.hide();
            tooltip.setContent({ '.tooltip-inner': 'Copy link' });
        }, 1500);
        });
    });
}

export { dm_single };